module.exports = __webpack_public_path__ + "img/noteObjection.7e7532a9.png";